<app-section-grid [subSection]="'Activate Company'"></app-section-grid>

<app-stepper-grid></app-stepper-grid>

<div class="relative w-full max-w-4xl mx-auto p-10 bg-white rounded-3xl border border-gray-200 mb-5">
  
  <!-- Minimal Success Message -->
  <div class="flex flex-col items-center justify-center py-12">
    
    <!-- Success Icon -->
    <div class="mb-8">
      <mat-icon class="text-green-500" style="font-size: 96px; width: 96px; height: 96px;">
        check_circle
      </mat-icon>
    </div>
    
    <!-- Success Message -->
    <h1 class="text-3xl font-bold text-gray-900 mb-4 text-center">
      Company Created!
    </h1>
    
    <p class="text-gray-600 mb-10 text-center max-w-xl">
      Company details have been successfully created and saved. Activation approval is needed before the users can initialize login.
    </p>
    
    <!-- Large Activate Button -->
    <button 
      class="w-full max-w-sm py-5 px-8 bg-green-600 hover:bg-green-700 
             text-white font-bold text-xl rounded-xl shadow-lg transition-all duration-300 
             transform hover:scale-[1.02] active:scale-[0.98] cursor-pointer">
      Activate Company
    </button>
    
    <!-- Dashboard Link -->
    <button 
      (click)="goToAcounts()"
      class="mt-6 text-gray-500 hover:text-gray-700 font-medium cursor-pointer">
      Do it later
    </button>
  </div>
  
</div>

<app-footer-grid></app-footer-grid>
